import React, { useMemo } from 'react';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Info } from '~/eds/src/modules/Info/Info';
import { api } from '~/redux/api/createApi';
import { RoleAttributes } from '~/redux/api/methods/roles/roles';

import { permissionGroupsToInfoItem } from './RoleDetails.utils';

type Props = {
  role: RoleAttributes;
};

export const RoleDetails = ({ role }: Props) => {
  const { data: permissionGroups, isFetching } =
    api.endpoints.getPermissions.useQuery({});

  const infos = useMemo(() => {
    return (
      permissionGroups
        ?.map((permissionGroup) =>
          permissionGroupsToInfoItem(permissionGroup, role.permissions),
        )
        .filter((permissionGroups) => permissionGroups.props.length) ?? []
    );
  }, [permissionGroups, role.permissions]);

  return (
    <Layout pr={6} pl={6} pb={6}>
      <ContentContainer loadingContent={{ isLoading: isFetching }}>
        <Info
          sections={[
            {
              title: '',
              description: role.description,
              infos,
            },
          ]}
        />
      </ContentContainer>
    </Layout>
  );
};
